import { render } from "./kios-list.vue?vue&type=template&id=8eb1df10&scoped=true"
import script from "./kios-list.vue?vue&type=script&lang=js"
export * from "./kios-list.vue?vue&type=script&lang=js"

import "./kios-list.vue?vue&type=style&index=0&id=8eb1df10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb1df10"]])

export default __exports__